// ==============================
// KycGuard.js
// Higher-Order Component che protegge le route post-KYC
// Se il KYC non è completato, reindirizza al flusso KYC
// ==============================

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import { SEMANTIC } from '../styles/theme';

const KycGuard = ({ children }) => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  const verifyKycCompletion = useCallback(async () => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      navigate('/login');
      return;
    }

    try {
      const response = await API.get(`/kyc/status?user_id=${userId}`);
      const data = response.data;

      if (data.kyc_completed) {
        setAuthorized(true);
      } else {
        // KYC non completato: reindirizza al prossimo step
        navigate(data.next_route);
      }
    } catch (err) {
      console.error('Errore verifica KYC:', err);
      // In caso di errore, reindirizza al KYC per sicurezza
      navigate('/kyc/email-verification');
    } finally {
      setChecking(false);
    }
  }, [navigate]);

  useEffect(() => {
    verifyKycCompletion();
  }, [verifyKycCompletion]);

  if (checking) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: SEMANTIC.backgroundApp,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ color: SEMANTIC.ctaPrimary, width: '2rem', height: '2rem' }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return authorized ? children : null;
};

export default KycGuard;
